import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=6d68aaf7&"
import script from "./Explanation.vue?vue&type=script&lang=js&"
export * from "./Explanation.vue?vue&type=script&lang=js&"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=6d68aaf7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports